<app-toast />
<p-confirmDialog />

<app-card-content [border]="false" [title]="'Módulos'" [icon]="'pi pi-th-large'">
    <div card-subtitle class="text-sm text-muted-color">Habilite ou desabilite, por UF, os módulos exibidos no portal.</div>

    <div card-header class="flex items-center gap-2">
        <p-button label="Cancelar" severity="secondary" [text]="true" [disabled]="qtdAlteradas() === 0 || salvando()" (onClick)="cancelar()" />
        <p-button [label]="qtdAlteradas() > 0 ? 'Salvar (' + qtdAlteradas() + ')' : 'Salvar'" icon="pi pi-check" [disabled]="qtdAlteradas() === 0" [loading]="salvando()" (onClick)="salvar()" [appCan]="roleModulosEditar" />
    </div>

    <!-- ── Filtros ── -->
    <app-filtros-bar (limpar)="limparFiltro()" (filtrar)="aplicarFiltro()">
        <app-filtro-campo label="UF">
            <app-estado-select class="flex-1 min-w-0" [uf]="uf()" [disabled]="ufTravada()" (ufChange)="onSelecionarUf($event)" />
        </app-filtro-campo>
        <app-filtro-campo label="Nome ou descrição" [wide]="true" inputId="modulos-filtro-texto">
            <input id="modulos-filtro-texto" pInputText type="text" class="w-full" [ngModel]="filtroInput()" (ngModelChange)="filtroInput.set($event)" (keyup.enter)="aplicarFiltro()" placeholder="Buscar módulo..." />
        </app-filtro-campo>
    </app-filtros-bar>

    <div class="flex flex-col gap-5 pt-1 mb-10">
        @if (qtdAlteradas() > 0) {
            <div class="pendencias-aviso flex items-center gap-2 text-sm">
                <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
                {{ qtdAlteradas() }} {{ qtdAlteradas() === 1 ? 'módulo alterado' : 'módulos alterados' }} — clique em "Salvar" para aplicar.
            </div>
        }

        <app-table-view-switcher [viewMode]="viewMode()" (viewModeChange)="viewMode.set($event)" />

        @if (carregando()) {
            <div class="flex flex-col items-center justify-center py-20 gap-3">
                <i class="pi pi-spin pi-spinner text-3xl text-primary opacity-50" aria-hidden="true"></i>
                <span class="text-sm text-surface-400 tracking-widest uppercase">Carregando</span>
            </div>
        } @else if (!uf()) {
            <div class="flex flex-col items-center justify-center py-20 gap-3 text-surface-400">
                <i class="pi pi-map-marker text-5xl" aria-hidden="true"></i>
                <span class="text-base">Selecione uma UF para ver os módulos.</span>
            </div>

            <!-- View: Cards -->
        } @else if (viewMode() === 'card') {
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                @for (item of itens(); track item.idWebModulo) {
                    <app-card-container [leftBorder]="estaAlterado(item)" [leftBorderColor]="'var(--p-primary-color)'">
                        <div class="flex flex-col gap-3 h-full">
                            <div class="flex items-start justify-between gap-2">
                                <span class="modulo-icone">
                                    <i [class]="item.dsClassIcon || 'pi pi-th-large'" aria-hidden="true"></i>
                                </span>
                                @if (podeEditarCatalogo()) {
                                    <p-button icon="pi pi-pencil" [text]="true" [rounded]="true" size="small" pTooltip="Editar" [ariaLabel]="'Editar ' + item.nmModulo" (onClick)="abrirEdicao(item)" [appCan]="roleModulosEditar" />
                                }
                            </div>
                            <div>
                                <h3 class="text-base font-semibold text-color truncate" [pTooltip]="item.nmModulo">{{ item.nmModulo }}</h3>
                                @if (!item.inAtivoGlobal) {
                                    <span class="inline-flex items-center gap-1 mt-1 bg-surface-100 dark:bg-surface-700 text-surface-500 dark:text-surface-400 text-sm font-bold px-2 py-0.5 rounded-full tracking-wide">Inativo globalmente</span>
                                }
                            </div>
                            <p class="text-sm text-muted-color line-clamp-3 flex-1">{{ item.dsModulo }}</p>
                            <div class="flex items-center gap-2 pt-2 border-t border-surface-200 dark:border-surface-700">
                                <span class="text-sm text-surface-500 dark:text-surface-400">Habilitado</span>
                                <p-toggleswitch [ngModel]="estadoAtual(item)" (ngModelChange)="onToggle(item, $event)" [appCan]="roleModulosEditar" />
                                @if (estaAlterado(item)) {
                                    <span class="badge-alterado" pTooltip="Alteração pendente — clique em Salvar para aplicar">Alterado</span>
                                }
                            </div>
                        </div>
                    </app-card-container>
                } @empty {
                    <div class="col-span-full flex flex-col items-center justify-center py-12 text-surface-400">
                        <i class="pi pi-inbox text-5xl mb-3" aria-hidden="true"></i>
                        <span>Nenhum módulo encontrado.</span>
                    </div>
                }
            </div>

            <!-- View: Tabela -->
        } @else {
            <p-table [value]="itens()" dataKey="idWebModulo" [tableStyle]="{ 'min-width': '48rem' }" [rowHover]="true" stripedRows>
                <ng-template pTemplate="header">
                    <tr>
                        <th class="w-16 text-center"><strong>Ícone</strong></th>
                        <th class="w-64"><strong>Nome</strong></th>
                        <th><strong>Descrição</strong></th>
                        <th class="w-36 text-center"><strong>Habilitado</strong></th>
                        <th class="w-24 text-center"><strong>Ações</strong></th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-item>
                    <tr [class.linha-alterada]="estaAlterado(item)">
                        <td class="text-center">
                            <span class="modulo-icone modulo-icone--sm">
                                <i [class]="item.dsClassIcon || 'pi pi-th-large'" aria-hidden="true"></i>
                            </span>
                        </td>
                        <td>
                            <span class="text-sm font-semibold text-surface-700 dark:text-surface-200">{{ item.nmModulo }}</span>
                            @if (!item.inAtivoGlobal) {
                                <span class="inline-flex items-center gap-1 bg-surface-100 dark:bg-surface-700 text-surface-500 dark:text-surface-400 text-sm font-bold px-2 py-0.5 rounded-full tracking-wide ml-2">Inativo globalmente</span>
                            }
                        </td>
                        <td>
                            <span class="text-sm text-surface-600 dark:text-surface-400">{{ item.dsModulo }}</span>
                        </td>
                        <td class="text-center">
                            <div class="flex items-center justify-center gap-2">
                                <p-toggleswitch [ngModel]="estadoAtual(item)" (ngModelChange)="onToggle(item, $event)" [appCan]="roleModulosEditar" />
                                @if (estaAlterado(item)) {
                                    <span class="badge-alterado" pTooltip="Alteração pendente — clique em Salvar para aplicar">Alterado</span>
                                }
                            </div>
                        </td>
                        <td class="text-center">
                            @if (podeEditarCatalogo()) {
                                <p-button icon="pi pi-pencil" [text]="true" [rounded]="true" size="small" pTooltip="Editar" [ariaLabel]="'Editar ' + item.nmModulo" (onClick)="abrirEdicao(item)" [appCan]="roleModulosEditar" />
                            }
                        </td>
                    </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="5" class="py-12 text-center text-sm text-surface-400 dark:text-surface-600 italic">Nenhum módulo encontrado.</td>
                    </tr>
                </ng-template>
            </p-table>
        }
    </div>
</app-card-content>

<app-modulo-detalhe [(visivel)]="edicaoVisivel" [modulo]="moduloEmEdicao()" (salvo)="onModuloSalvo()" />
